import {
  Directive,
  ElementRef,
  HostListener,
  Renderer2,
  inject,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import {
  addPercentageFormat,
  removePercentageFormat,
} from '@qtek/shared/utils';

@Directive({
  selector: 'input[qtPercentControl]',
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: PercentInputDirective,
      multi: true,
    },
  ],
})
export class PercentInputDirective implements ControlValueAccessor {
  private readonly _elementRef =
    inject<ElementRef<HTMLInputElement>>(ElementRef);
  private readonly _renderer = inject(Renderer2);

  private readonly maxNumbersAfterDot = 3;
  value: string;

  @HostListener('input', ['$event'])
  onInput(event: any) {
    this.value = this.getValueFromEvent(event);

    // When the user clears the input, emit null so the form control is
    // persisted as "no value" instead of being coerced to 0 by
    // removePercentageFormat(Number('')) === 0.
    this.onChange(
      this.value === '' ? null : removePercentageFormat(this.value)
    );

    event.target.value = this.value;
  }

  @HostListener('blur', ['$event'])
  onBlur(event: any) {
    this.value = this.getValueFromEvent(event);

    this.onTouched(
      this.value === '' ? null : removePercentageFormat(this.value)
    );

    event.target.value = this.value;
  }

  private getValueFromEvent(event: any) {
    const rawValue: string = event.target.value;
    const value: string = event.target.value.match(
      /(\d+([.]\d*)?|[.]\d+)/g
    )?.[0];

    if (!rawValue.trim()) {
      return '';
    } else if (value === undefined) {
      return '0';
    } else {
      const splitedVal = value.split('.');
      if (splitedVal[1]?.length > this.maxNumbersAfterDot) {
        splitedVal[1] = splitedVal[1].slice(0, this.maxNumbersAfterDot);
      }

      return splitedVal.join('.');
    }
  }

  onChange = (value: string) => {
    return;
  };
  onTouched = (value: string) => {
    return;
  };

  writeValue(rawPercents: string): void {
    if (
      rawPercents === null ||
      rawPercents === undefined ||
      rawPercents === ''
    ) {
      this.value = '';
    } else {
      this.value = addPercentageFormat(rawPercents);
    }
    this._renderer.setAttribute(
      this._elementRef.nativeElement,
      'value',
      this.value
    );
  }

  registerOnChange(fn: (_: any) => void): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
}
